module.exports = __webpack_public_path__ + "static/media/fhj-logo.40cfdd4a.png";